import { createSlice } from "@reduxjs/toolkit";

interface DataState {
  form: string | null;
}

const initialState: DataState = {
  form: null,
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setForm: (state, action) => {
      state.form = action.payload;
    },
  },
});

export const { setForm } = formSlice.actions;
export default formSlice.reducer;
